import { render, staticRenderFns } from "./QuickBIEmbedJSSdk.vue?vue&type=template&id=e8395848&scoped=true&"
import script from "./QuickBIEmbedJSSdk.vue?vue&type=script&lang=js&"
export * from "./QuickBIEmbedJSSdk.vue?vue&type=script&lang=js&"
import style0 from "./QuickBIEmbedJSSdk.vue?vue&type=style&index=0&id=e8395848&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8395848",
  null
  
)

export default component.exports